import { render, staticRenderFns } from "./AccountRegister.vue?vue&type=template&id=87fd8f12"
import script from "./AccountRegister.vue?vue&type=script&lang=js"
export * from "./AccountRegister.vue?vue&type=script&lang=js"
import style0 from "./AccountRegister.vue?vue&type=style&index=0&id=87fd8f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports